@if (loading$ | async) {
  <div class="spinner-container overlay-spinner" role="status" aria-live="polite">
    <div class="spinner-card flex justify-center">
      <p-progress-spinner
        strokeWidth="2"
        fill="transparent"
        animationDuration="2s"
        [style]="{ width: '100px', height: '100px' }"
        ariaLabel="Loading..." />
    </div>
  </div>
}
